/*
Copyright 2021 Tamal Anwar Chowdhury

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React, { Component } from 'react';
import { elements } from './_data_safety_layout';

export default class DayMachineElement extends Component {
  state = {
    hover: false,
  };

  openInfo = (event) => {
    this.props.showInfo(this.props.num);
  };

  onMouseEnter = (event) => {
    this.setState({ hover: true });
  };

  onMouseLeave = (event) => {
    this.setState({ hover: false });
  };

  render() {
    let { num } = this.props;
    let { color } = this.props;
    let { issues } = this.props;
    return (
      <div
        title={num}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.openInfo}
        className={`${
          this.props.oneTypeIssue === true ? 'element-one-type-issue' : 'element'
        } element_machine_fac-${num} ${color} ${
          this.state.hover || (this.props.lastClickedElement == num && this.props.lastGroupClicked == 3) ? 'active' : ''
        }`}
      >
        {/* <div className="number">{element.number}</div> */}
        <div className="symbol" style={color == 'yellow_state' ? { color: 'black' } : undefined}>
          {num < 32 ? num : ''}
        </div>
        {/* <div className="element-name">{element.name}</div> */}
      </div>
    );
  }
}
